module.exports = __webpack_public_path__ + "296be68a6cfe70c42251c0e45756772b.MP3";